import { render, staticRenderFns } from "./CollectionActPerformance.vue?vue&type=template&id=ce4c579e&scoped=true"
import script from "./CollectionActPerformance.vue?vue&type=script&lang=js"
export * from "./CollectionActPerformance.vue?vue&type=script&lang=js"
import style0 from "./CollectionActPerformance.vue?vue&type=style&index=0&id=ce4c579e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce4c579e",
  null
  
)

export default component.exports